import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  containerBox: {
    margin: theme.spacing(0, 3),
    display: 'flex',
    flexDirection: 'column',
  },
  link: {
    cursor: 'pointer',
    color: theme.palette.primary.hover,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  inputFile: {
    display: 'none',
  },
}))

export default styles
